// extracted by mini-css-extract-plugin
export default {"modelSectionHeading":"_2Kk776o299WfhS5EIAqPjF","modelSectionFlex":"_1PWS-cJ6XMwfsA--v17IKy"};